import TcButton from 'components/UI/button/TcButton';
import TcFormWrapper from 'components/UI/FormWrapper/TcFormWrapper';
import TcModal from 'components/UI/Modal/TcModal';
import TcShowInfo from 'components/UI/ShowInfo/TcShowInfo';
import endpointUrls from 'global/Constants/endpointUrls';
import { encryptId } from 'global/helperFunctions/hashquery';
import ApiService from 'global/utils/ApiService';
import { memo, useEffect } from 'react';
import { useHistory } from 'react-router';
import { getMyNotifications } from 'redux/reducer/notification/getMyNotifications';
import { store } from 'redux/store';

const NotificationDetail = ({ detail, close, handleSeen, userId }) => {
  //effects
  useEffect(() => {
    detail && handleSeen && makeNotifitacionSeen();
  }, [detail]);

  //hooks
  const history = useHistory();

  //functions
  const makeNotifitacionSeen = async () => {
    if (detail.seen) return;
    await ApiService.put(endpointUrls.notificationUpdate, { ...detail, seen: true })
      .then(() => {
        userId && store.dispatch(getMyNotifications(userId));
      })
      .catch(() => {});
  };

  return (
    <TcModal
      visible={detail}
      title='جزئیات اعلان'
      footer={false}
      onCancel={close}
      headStyle={{ backgroundColor: 'var(--bg-color) !important' }}
      styles={{ body: { backgroundColor: 'var(--bg-color)' } }}>
      <TcFormWrapper singleColumn>
        <TcShowInfo right='عنوان' left={detail?.title} />
        {!handleSeen && <TcShowInfo right='زمان ایجاد' left={detail?.creationDate} />}
        {!handleSeen && <TcShowInfo right='فرد گیرنده' left={detail?.fullName} />}
        {!handleSeen && <TcShowInfo right='دیده شده' left={detail?.seen ? 'بلی' : 'خیر'} />}
        {!handleSeen && <TcShowInfo right='پیامک ارسال شده' left={detail?.sendSMS ? 'بلی' : 'خیر'} />}
        {!handleSeen && <TcShowInfo right='در اپ نمایش داده شده' left={detail?.sendInApp ? 'بلی' : 'خیر'} />}
      </TcFormWrapper>
      {detail?.url && <TcShowInfo right='لینک' left={detail?.url} />}
      <TcShowInfo right='متن' left={detail?.description} />

      {detail?.frontendRoute && (
        <div className='flex justify-end'>
          <TcButton
            type='primary'
            size='small'
            onClick={() => {
              history.push(detail.frontendRoute.url + encryptId(detail.contextId));
              close();
            }}>
            نمایش {detail.frontendRoute?.title}
          </TcButton>
        </div>
      )}
    </TcModal>
  );
};

export default memo(NotificationDetail);
